module.exports = __webpack_public_path__ + "media/images/area/area_okayamaM400-684bd8f28ab673819e2eaa23f203209c.jpg";